import React from 'react';
import {
  ListFilterBar,
  ListFilters,
  PAST_DATE_OPTIONS,
  SelectFilter,
} from '../../../components/ListFilterBar/ListFilterBar';

export type BillsFilters = ListFilters & {
  /** A verdict, "open" for the review queue, or "" for every bill. */
  status: string;
  claimType: string;
  billType: string;
};

// The bills page opens on the review queue: what still needs a decision.
export const DEFAULT_BILLS_FILTERS: BillsFilters = {
  search: '',
  status: 'open',
  claimType: '',
  billType: '',
  datePreset: 'all',
};

const SELECTS: SelectFilter[] = [
  {
    key: 'status',
    id: 'bills-status',
    label: 'Status',
    options: [
      { value: 'open', label: 'Open' },
      { value: 'processing', label: 'Processing' },
      { value: 'processed', label: 'Processed' },
      { value: 'approved', label: 'Approved' },
      { value: 'partial-approved', label: 'Partially Approved' },
      { value: 'rejected', label: 'Rejected' },
      { value: 'paid', label: 'Paid' },
      { value: '', label: 'All statuses' },
    ],
  },
  {
    key: 'claimType',
    id: 'bills-claim-type',
    label: 'Claim Type',
    options: [
      { value: '', label: 'All claim types' },
      { value: 'Outpatient', label: 'Outpatient' },
      { value: 'Inpatient', label: 'Inpatient' },
      { value: 'Other', label: 'Other' },
    ],
  },
  {
    key: 'billType',
    id: 'bills-bill-type',
    label: 'Bill Type',
    options: [
      { value: '', label: 'All bill types' },
      { value: 'Professional', label: 'Professional' },
      { value: 'Institutional', label: 'Institutional' },
    ],
  },
];

type Props = {
  filters: BillsFilters;
  onChange: (next: BillsFilters) => void;
  total: number;
  /** Bulk approval only works on open bills, so it pins the status. */
  statusLocked?: boolean;
  tenantSlot?: React.ReactNode;
};

export function BillsFilterBar({ filters, onChange, total, statusLocked, tenantSlot }: Props) {
  return (
    <ListFilterBar
      filters={filters}
      defaults={DEFAULT_BILLS_FILTERS}
      onChange={onChange}
      total={total}
      noun="bills"
      searchPlaceholder="Search by case ID, policy number, bill ID or provider"
      selects={SELECTS}
      dateLabel="Date of Service"
      dateOptions={PAST_DATE_OPTIONS}
      locked={{ status: !!statusLocked }}
      tenantSlot={tenantSlot}
    />
  );
}
